'use client'

import { useEffect } from 'react'
import { usePricingData } from '@/hooks/use-pricing-data'

interface PricingPreloaderProps {
  preload?: boolean
  children?: React.ReactNode
}

export const PricingPreloader = ({ preload = true, children }: PricingPreloaderProps) => {
  const { data, isLoading, error } = usePricingData()

  useEffect(() => {
    if (preload && data) {
      // Store in sessionStorage for immediate access
      sessionStorage.setItem('pricing-data-cache', JSON.stringify({
        data,
        timestamp: Date.now()
      }))
    }
  }, [data, preload])

  // Optionally show loading state for critical pricing pages
  if (children) {
    return <>{children}</>
  }

  return null
}

// Hook to get cached pricing data from sessionStorage immediately
export const useCachedPricingData = () => {
  const getCachedData = () => {
    if (typeof window === 'undefined') return null
    
    try {
      const cached = sessionStorage.getItem('pricing-data-cache')
      if (cached) {
        const parsed = JSON.parse(cached)
        // Check if cache is less than 5 minutes old
        if (Date.now() - parsed.timestamp < 5 * 60 * 1000) {
          return parsed.data
        }
      }
    } catch (error) {
    }
    return null
  }

  return { getCachedData }
}